import {
    FETCH_PERMISSIONS_PENDING,
    FETCH_PERMISSIONS_FULFILLED,
    FETCH_PERMISSIONS_REJECTED
  } from "../constants/permissions";
  
  const initialState = {
    permissions: [],
    pending: false,
    error: null
  };
  
  export const permissions = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PERMISSIONS_PENDING: 
        return {
          ...state,
          pending: true,
          error: null
        };
  
      case FETCH_PERMISSIONS_FULFILLED: 
        return {
          ...state,
          permissions: action.data,
          pending: false,
          error: null
        };
      
      case FETCH_PERMISSIONS_REJECTED: 
        return {
          ...state,
          pending: false,
          error: action.error
        };
  
      default:
        return state;
    }
  };


// WEBPACK FOOTER //
// ./src/reducers/permissions.js